/*
 * DSD Runtime Bootstrap Validator – p11dz72
 * Infrastructure-safe continuation of Runtime Intelligence V2.
 * Goals:
 * - verify/canonicalize the .dsd-overlay-root mount
 * - record RouteShell / overlay bootstrap checkpoints
 * - trace mutation targets so high mutation churn becomes actionable
 * - enrich dashboard/JSON/HTML snapshot exports without requiring screenshots
 */
(function(){
  if (window.DSDRuntimeBootstrapValidator && window.DSDRuntimeBootstrapValidator.version) return;
  var VERSION = 'p11dz92-native-route-shell-v1';
  var MAX = 160;
  var state = {
    version: VERSION,
    startedAt: new Date().toISOString(),
    overlayRoot: null,
    routeShell: null,
    checks: [],
    mutationSamples: [],
    mutationTotals: {},
    mutationBursts: [],
    lastMutationAt: null,
    notes: []
  };
  function now(){ return new Date().toISOString(); }
  function perf(){ try { return Math.round(performance.now()*100)/100; } catch(e){ return Date.now(); } }
  function cap(arr,n){ n=n||MAX; while(arr.length>n) arr.shift(); }
  function claim(surface, owner, meta){
    if (window.DSDRegistry && typeof window.DSDRegistry.claim === 'function') {
      try { window.DSDRegistry.claim(surface, owner, meta || {}); } catch(e){}
    }
  }
  function violation(code, message, meta){
    if (window.DSDRegistry && typeof window.DSDRegistry.reportViolation === 'function') {
      try { window.DSDRegistry.reportViolation(code, message, meta || {}); } catch(e){}
    }
  }
  function checkpoint(stage, status, detail){
    var rec = { stage: stage, status: status || 'observed', detail: detail || '', at: now(), ms: perf() };
    state.checks.push(rec); cap(state.checks);
    if (window.DSDRuntimeGovernance && typeof window.DSDRuntimeGovernance.checkpoint === 'function') {
      try { window.DSDRuntimeGovernance.checkpoint(stage, status || 'observed', detail || ''); } catch(e){}
    } else {
      claim('bootstrap-'+String(stage).toLowerCase().replace(/[^a-z0-9]+/g,'-'), 'RuntimeBootstrapValidator', { status: status || 'observed', stage: stage, detail: detail || '', version: VERSION });
    }
    return rec;
  }
  function shortNode(el){
    if (!el || el.nodeType !== 1) return String(el && el.nodeName || 'node');
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    if (el.className && typeof el.className === 'string') {
      var cls = el.className.trim().split(/\s+/).filter(Boolean).slice(0,3).join('.');
      if (cls) s += '.' + cls;
    }
    return s;
  }
  function ensureOverlayRoot(){
    var roots = Array.prototype.slice.call(document.querySelectorAll('.dsd-overlay-root'));
    var root = roots[0] || null;
    if (!root) {
      root = document.createElement('div');
      root.className = 'dsd-overlay-root';
      root.setAttribute('data-dsd-owner','OverlayManager');
      root.setAttribute('data-dsd-bootstrap','p11dz72');
      root.setAttribute('aria-hidden','true');
      document.body.appendChild(root);
      checkpoint('OVERLAY_ROOT_CREATED','pass','.dsd-overlay-root created by bootstrap validator because the canonical root was missing');
      claim('overlay-root:bootstrap-created', 'OverlayManager', { version: VERSION, selector: '.dsd-overlay-root', reason: 'missing canonical overlay root' });
    } else {
      if (!root.getAttribute('data-dsd-owner')) root.setAttribute('data-dsd-owner','OverlayManager');
      checkpoint('OVERLAY_ROOT_PRESENT','pass','.dsd-overlay-root found');
      claim('overlay-root:bootstrap-present', 'OverlayManager', { version: VERSION, selector: '.dsd-overlay-root', count: roots.length });
    }
    if (roots.length > 1) {
      checkpoint('OVERLAY_ROOT_DUPLICATE','warn', roots.length + ' .dsd-overlay-root nodes detected');
      violation('OVERLAY_ROOT_DUPLICATE', 'Multiple .dsd-overlay-root nodes detected', { count: roots.length, version: VERSION });
    }
    try {
      if (window.DSDOverlayManager) {
        window.DSDOverlayManager.root = root;
        claim('overlay-manager:root-bound', 'OverlayManager', { version: VERSION, selector: '.dsd-overlay-root' });
      }
    } catch(e){}
    state.overlayRoot = { exists: true, count: Math.max(1, roots.length), created: !roots.length, selector: '.dsd-overlay-root', owner: 'OverlayManager', at: now() };
    return root;
  }
  function routeHost(){
    return document.querySelector('#MainContent') || document.querySelector('main') || document.body;
  }
  function socialRouteType(){
    var path = location.pathname || '/';
    if (/\/pages\/(users|members)/.test(path)) return 'user-discovery';
    if (/\/pages\/(user-profile|user-profile)/.test(path)) return 'user-profile';
    if (/\/pages\/(feed|community)/.test(path)) return 'community-feed';
    if (/\/pages\/following/.test(path)) return 'following-feed';
    if (/\/pages\/social/.test(path)) return 'social-hub';
    return '';
  }
  function markSocialRoute(){
    var type = socialRouteType();
    if (!type || !document.body) return;
    var routeClass = type === 'user-profile' ? 'dsd-social-route-profile' : (type === 'user-discovery' ? 'dsd-social-route-users' : 'dsd-social-route-feed');
    if (!document.body.classList.contains('dsd-social-route')) document.body.classList.add('dsd-social-route');
    if (!document.body.classList.contains(routeClass)) document.body.classList.add(routeClass);
    if (document.body.getAttribute('data-dsd-social-route') !== type) document.body.setAttribute('data-dsd-social-route', type);
  }
  function suppressTemplateBleed(routeType){
    routeType = routeType || socialRouteType();
    if (!routeType) return [];
    markSocialRoute();
    var host = routeHost();
    var suppressed = [];
    var selectors = [
      '.shopify-section.section-collection-list',
      '.shopify-section:has(.collection-list-wrapper)',
      '.shopify-section:has(.collection-list)',
      '.shopify-section:has(.featured-collection)',
      '[id*="collection_list"]',
      '[id*="collection-list"]',
      '[id*="featured_collection"]'
    ];
    selectors.forEach(function(sel){
      var nodes = [];
      try { nodes = Array.prototype.slice.call((host || document).querySelectorAll(sel)); } catch(e) { nodes = []; }
      nodes.forEach(function(section){
        if (!section || section.id === 'dsd-canonical-social-autoshell' || section.id === 'dsd-canonical-profile-autoshell') return;
        if (section.closest('#dsd-canonical-social-autoshell, #dsd-canonical-profile-autoshell, .dsd-overlay-root')) return;
        if (section.querySelector('#dsd-canonical-social-autoshell, #dsd-canonical-profile-autoshell')) return;
        if (section.getAttribute('data-dsd-suppressed-social-bleed') === 'true') return;
        section.setAttribute('data-dsd-suppressed-social-bleed','true');
        section.setAttribute('data-dsd-suppressed-reason','commerce section rendered on canonical social route');
        section.style.display = 'none';
        suppressed.push(section.id || section.className || section.tagName);
      });
    });
    if (suppressed.length) {
      checkpoint('TEMPLATE_BLEED_SUPPRESSED','pass','hid non-social commerce sections on '+routeType+': '+suppressed.join(', '));
      claim('route-shell:template-bleed-suppressed','RouteShell',{ version:VERSION, route:routeType, suppressed:suppressed });
    }
    return suppressed;
  }
  function makeAnchor(id, className, contract){
    var existing = document.getElementById(id);
    if (existing) return existing;
    var el = document.createElement('div');
    el.id = id;
    el.className = className || id;
    el.setAttribute('data-dsd-contract', contract || id);
    el.setAttribute('data-dsd-owner','RouteShell');
    el.setAttribute('data-dsd-bootstrap','p11dz85-route-shell-repair');
    return el;
  }
  function ensureRouteShell(){
    var path = location.pathname || '/';
    var host = routeHost();
    var repaired = [];
    markSocialRoute();
    if (/\/pages\/(users|members)/.test(path)) {
      var nativeUsersWrap = document.getElementById('dsd-native-social-route-shell') || document.querySelector('[data-dsd-route="users"], [data-dsd-route="user-discovery"]');
      var hasUserAnchors = !!document.getElementById('dsd-users-container');
      if (hasUserAnchors) {
        checkpoint('ROUTE_SHELL_NATIVE_PRESENT','pass','native user discovery route anchors already present');
        claim('route-shell:native-anchors-present','RouteShell',{ version:VERSION, path:path, route:'user-discovery', shell:nativeUsersWrap ? (nativeUsersWrap.id || nativeUsersWrap.getAttribute('data-dsd-route')) : 'existing-dom', anchors:['#dsd-users-container'], noFeed:true, noComposer:true });
      } else {
        var wrapUsers = document.getElementById('dsd-canonical-users-autoshell');
        if (!wrapUsers) {
          wrapUsers = document.createElement('section');
          wrapUsers.id = 'dsd-canonical-users-autoshell';
          wrapUsers.className = 'dsd-canonical-social-app dsd-canonical-social-app--autoshell dsd-social-route-shell--users';
          wrapUsers.setAttribute('data-dsd-owner','RouteShell');
          wrapUsers.setAttribute('data-dsd-route','user-discovery');
          host.appendChild(wrapUsers);
        }
        if (!document.getElementById('dsd-users-container')) { wrapUsers.appendChild(makeAnchor('dsd-users-container','dsd-users-container dsd-user-discovery-route','user-discovery-route')); repaired.push('#dsd-users-container'); }
      }
    } else if (/\/pages\/(feed|community|following)/.test(path)) {
      var nativeWrap = document.getElementById('dsd-native-social-route-shell') || document.querySelector('[data-dsd-route="feed"], [data-dsd-route="following"]');
      var hasNativeAnchors = !!(document.getElementById('dsd-feed-container') && document.getElementById('dsd-composer-container') && document.getElementById('dsd-notification-root'));
      if (hasNativeAnchors) {
        checkpoint('ROUTE_SHELL_NATIVE_PRESENT','pass','native feed route anchors already present');
        claim('route-shell:native-anchors-present','RouteShell',{ version:VERSION, path:path, route:socialRouteType(), shell:nativeWrap ? (nativeWrap.id || nativeWrap.getAttribute('data-dsd-route')) : 'existing-dom', anchors:['#dsd-composer-container','#dsd-feed-container','#dsd-notification-root'] });
      } else {
        var wrap = document.getElementById('dsd-canonical-social-autoshell');
        if (!wrap) {
          wrap = document.createElement('section');
          wrap.id = 'dsd-canonical-social-autoshell';
          wrap.className = 'dsd-canonical-social-app dsd-canonical-social-app--autoshell';
          wrap.setAttribute('data-dsd-owner','RouteShell');
          wrap.setAttribute('data-dsd-route', socialRouteType() || 'community-feed');
          host.appendChild(wrap);
        }
        [['dsd-composer-container','dsd-composer-container','post-composer'],['dsd-feed-container','dsd-feed-container','community-feed'],['dsd-notification-root','dsd-notification-root','notifications']].forEach(function(x){
          if (!document.getElementById(x[0])) { wrap.appendChild(makeAnchor(x[0],x[1],x[2])); repaired.push('#'+x[0]); }
        });
      }
    } else if (/\/pages\/(user-profile|user-profile)/.test(path)) {
      var nativeProfileWrap = document.getElementById('dsd-native-profile-route-shell') || document.querySelector('[data-dsd-route="profile"], [data-dsd-route="user-profile"], [data-dsd-route="user-profile"]');
      var hasNativeProfileAnchors = !!(document.querySelector('[data-dsd-user-profile]') || document.getElementById('dsd-profile-container')); /* p11dz256: fresh user-profile layout owns profile route */
      if (hasNativeProfileAnchors) {
        checkpoint('ROUTE_SHELL_NATIVE_PRESENT','pass','native profile route anchors already present');
        claim('route-shell:native-anchors-present','RouteShell',{ version:VERSION, path:path, route:'user-profile', shell:nativeProfileWrap ? (nativeProfileWrap.id || nativeProfileWrap.getAttribute('data-dsd-route')) : 'existing-dom', anchors:['[data-dsd-user-profile]','#dsd-profile-container'] });
      } else {
        var wrap2 = document.getElementById('dsd-canonical-profile-autoshell');
        if (!wrap2) {
          wrap2 = document.createElement('section');
          wrap2.id = 'dsd-canonical-profile-autoshell';
          wrap2.className = 'dsd-canonical-social-app dsd-canonical-social-app--autoshell';
          wrap2.setAttribute('data-dsd-owner','RouteShell');
          wrap2.setAttribute('data-dsd-route','user-profile');
          host.appendChild(wrap2);
        }
        [['dsd-profile-container','dsd-profile-container','user-profile'],['dsd-notification-root','dsd-notification-root','notifications']].forEach(function(x){
          if (!document.getElementById(x[0]) && !document.querySelector('[data-dsd-user-profile]')) { wrap2.appendChild(makeAnchor(x[0],x[1],x[2])); repaired.push('#'+x[0]); }
        });
      }
    }
    var suppressed = suppressTemplateBleed();
    if (repaired.length) {
      checkpoint('ROUTE_SHELL_REPAIRED','pass','created canonical route anchors: '+repaired.join(', '));
      claim('route-shell:auto-created-anchors','RouteShell',{ version:VERSION, path:path, anchors:repaired, reason:'Shopify template/section did not mount required DSD route shell' });
    }
    return repaired.concat(suppressed.map(function(x){ return 'suppressed:'+x; }));
  }
  function validateRouteShell(){
    ensureRouteShell();
    var path = location.pathname || '/';
    var expected = [];
    if (/\/pages\/(user-profile|user-profile)/.test(path)) expected = ['#dsd-profile-container'];
    else if (/\/pages\/(users|members)/.test(path)) expected = ['#dsd-users-container'];
    else if (/\/pages\/(feed|community|following)/.test(path)) expected = ['#dsd-feed-container'];
    else if (/\/pages\/dsd-videos|\/pages\/videos/.test(path)) expected = ['#dsd-video-feed','[data-dsd-contract="video-feed"]'];
    else expected = ['main'];
    var found = expected.map(function(sel){ var count=0; try{ count=document.querySelectorAll(sel).length; }catch(e){} return { selector: sel, count: count }; });
    var ok = found.some(function(x){ return x.count>0; });
    state.routeShell = { path: path, expected: expected, anchors: found, status: ok ? 'ready' : 'blocked', at: now() };
    checkpoint('ROUTE_SHELL_VALIDATE', ok ? 'pass' : 'warn', ok ? ('route anchor found: '+found.filter(function(x){return x.count>0;}).map(function(x){return x.selector+'='+x.count;}).join(', ')) : ('no route anchor found for '+path));
    if (!ok) violation('ROUTE_SHELL_ANCHOR_MISSING','No canonical route shell anchor found',{ path:path, expected:expected, version:VERSION });
    claim('route-shell:bootstrap-validated', 'RouteShell', { version: VERSION, status: state.routeShell.status, path: path, anchors: found });
    return state.routeShell;
  }
  function mutationKeyFor(node){
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    var limit = 0;
    while(el && limit++ < 4){
      var label = shortNode(el);
      if (/dsd-|shopify-section|MainContent|main|body|html/.test(label)) return label;
      el = el.parentElement;
    }
    return shortNode(node);
  }

  function isForensicsNode(el){
    try { return !!(el && el.nodeType === 1 && el.closest && el.closest('.dsd-forensics-panel, .dsd-forensics-body, .dsd-forensics-actions, #dsd-forensics-launcher')) } catch(e){ return false; }
  }
  function meaningfulMutationNode(list){
    var arr = Array.prototype.slice.call(list || []);
    for (var i=0;i<arr.length;i++){
      var n = arr[i];
      if (!n || n.nodeType !== 1) continue;
      if (isForensicsNode(n)) continue;
      var label = shortNode(n);
      if (/script|style|link|meta/.test(label)) continue;
      return n;
    }
    return null;
  }
  function mutationKeyForRecord(r){
    if (!r) return 'unknown-mutation';
    if (isForensicsNode(r.target)) return '';
    if (r.type === 'attributes') {
      return mutationKeyFor(r.target) + ':attr:' + (r.attributeName || 'attr');
    }
    if (r.type === 'childList') {
      var added = meaningfulMutationNode(r.addedNodes);
      var removed = meaningfulMutationNode(r.removedNodes);
      var node = added || removed;
      if (node) {
        if (node.id === 'dsd-canonical-social-autoshell' || node.id === 'dsd-canonical-profile-autoshell') return 'RouteShell:canonical-autoshell-childList';
        if (node.closest && node.closest('#dsd-canonical-social-autoshell,#dsd-canonical-profile-autoshell')) return 'RouteShell:canonical-social-shell-childList';
        return shortNode(node) + ':childList';
      }
      var targetLabel = mutationKeyFor(r.target);
      if (/^body|^html/.test(targetLabel)) return 'document-shell:childList';
      return targetLabel + ':childList';
    }
    return mutationKeyFor(r.target);
  }
  var burst = { start: Date.now(), count: 0, targets: {} };
  function flushBurst(){
    if (!burst.count) return;
    var targets = Object.keys(burst.targets).sort(function(a,b){return burst.targets[b]-burst.targets[a];}).slice(0,10).map(function(k){return { target:k, count:burst.targets[k] };});
    var actionableTargets = targets.filter(function(t){ return !isCosmeticMutationTarget(t.target); });
    var actionableCount = actionableTargets.reduce(function(sum,t){ return sum + (t.count || 0); }, 0);
    var rec = { at: now(), durationMs: Date.now()-burst.start, count: burst.count, actionableCount: actionableCount, topTargets: targets, actionableTargets: actionableTargets };
    state.mutationBursts.push(rec); cap(state.mutationBursts,40);
    if (actionableCount >= 80) {
      violation('RUNTIME_MUTATION_SOURCE_TRACE','Actionable mutation burst source trace captured',{ count: actionableCount, totalObserved: burst.count, topTargets: actionableTargets, version: VERSION, policy: 'p11dz171-cosmetic-dawn-slick-compressed' });
    } else if (targets.length) {
      state.notes.push('p11dz171 compressed cosmetic/Dawn/Slick mutation burst: total '+burst.count+', actionable '+actionableCount); cap(state.notes,20);
    }
    burst = { start: Date.now(), count: 0, targets: {} };
  }
  function startMutationTrace(){
    if (!('MutationObserver' in window) || state._observerStarted) return;
    state._observerStarted = true;
    var obs = new MutationObserver(function(records){
      var sampleTargets = {};
      records.forEach(function(r){
        var key = mutationKeyForRecord(r);
        if (!key) return;
        state.mutationTotals[key] = (state.mutationTotals[key] || 0) + 1;
        sampleTargets[key] = (sampleTargets[key] || 0) + 1;
        burst.targets[key] = (burst.targets[key] || 0) + 1;
        burst.count++;
      });
      state.lastMutationAt = now();
      var sample = { at: state.lastMutationAt, count: records.length, targets: Object.keys(sampleTargets).sort(function(a,b){return sampleTargets[b]-sampleTargets[a];}).slice(0,8).map(function(k){return { target:k, count:sampleTargets[k] };}) };
      state.mutationSamples.push(sample); cap(state.mutationSamples,120);
    });
    try { obs.observe(document.documentElement || document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style','aria-hidden','data-state','open'] }); } catch(e){}
    setInterval(flushBurst, 1500);
    checkpoint('MUTATION_SOURCE_TRACE','pass','mutation source tracing active');
    claim('mutation-source-tracer:active','RuntimeBootstrapValidator',{ version: VERSION });
  }
  function topMutationTargets(){
    return Object.keys(state.mutationTotals).sort(function(a,b){return state.mutationTotals[b]-state.mutationTotals[a];}).slice(0,14).map(function(k){return { target:k, count:state.mutationTotals[k] };});
  }

  function isCosmeticMutationTarget(target){
    target = String(target || '');
    return /(^body\.gradient.*:attr:(class|style)$)|(^body.*animate--hover-default.*:attr:(class|style)$)|(^div\.star:childList$)|(^div#dsd-starfield-root-p11dz90:childList$)|(^span\.dsd-starfield-star.*:attr:(class|style)$)|(^span\.dsd-shooting-star.*:attr:(class|style)$)|(^div\.slick-slide.*:attr:(class|aria-hidden)$)|(^div#shopify-section-.*__header.*:attr:class$)|(^section#shopify-section-.*__collection_list.*:attr:style$)|(^ul#Slider-template.*:attr:style$)|(^li#Slide-template.*:attr:style$)|(^style:childList$)|(^head:childList$)|(^div\.dsd-story-thumb:childList$)/.test(target);
  }
  function classifiedMutationTargets(){
    var all = topMutationTargets();
    var cosmetic = [];
    var actionable = [];
    all.forEach(function(t){
      if (isCosmeticMutationTarget(t.target)) cosmetic.push(t);
      else actionable.push(t);
    });
    return { all: all, cosmetic: cosmetic, actionable: actionable };
  }

  function snapshot(){
    var classified = classifiedMutationTargets();
    return {
      version: VERSION,
      startedAt: state.startedAt,
      overlayRoot: state.overlayRoot,
      routeShell: state.routeShell,
      checks: state.checks.slice(),
      topMutationTargets: classified.all,
      cosmeticMutationTargets: classified.cosmetic,
      actionableMutationTargets: classified.actionable,
      mutationBursts: state.mutationBursts.slice(-20),
      recentMutationSamples: state.mutationSamples.slice(-20),
      lastMutationAt: state.lastMutationAt,
      notes: state.notes.slice()
    };
  }
  function boot(){
    checkpoint('BOOTSTRAP_VALIDATOR_BOOT','pass','Runtime bootstrap validator loaded');
    ensureOverlayRoot();
    validateRouteShell();
    startMutationTrace();
    setTimeout(function(){ ensureOverlayRoot(); validateRouteShell(); checkpoint('BOOTSTRAP_VALIDATOR_DEFERRED_AUDIT','pass','overlay root + route shell deferred validation completed'); }, 1400);
  }
  window.DSDRuntimeBootstrapValidator = { version: VERSION, ensureOverlayRoot: ensureOverlayRoot, validateRouteShell: validateRouteShell, startMutationTrace: startMutationTrace, suppressTemplateBleed: suppressTemplateBleed, snapshot: snapshot };
  // Enrich governance snapshots without replacing the existing governance engine.
  function enhanceGovernance(){
    if (!window.DSDRuntimeGovernance || !window.DSDRuntimeGovernance.analyze || window.DSDRuntimeGovernance.__p11dz72Enhanced) return;
    var original = window.DSDRuntimeGovernance.analyze;
    window.DSDRuntimeGovernance.analyze = function(base){
      var gov = original.call(window.DSDRuntimeGovernance, base);
      gov.bootstrapV2 = snapshot();
      if (gov.dom) {
        gov.dom.overlayRoots = document.querySelectorAll('.dsd-overlay-root').length;
      }
      gov.primaryBlockers = gov.primaryBlockers || [];
      if (gov.bootstrapV2.overlayRoot && gov.bootstrapV2.overlayRoot.exists) {
        gov.primaryBlockers = gov.primaryBlockers.filter(function(x){ return String(x).indexOf('No .dsd-overlay-root') === -1; });
      }
      var top = gov.bootstrapV2.topMutationTargets || [];
      var actionable = gov.bootstrapV2.actionableMutationTargets || [];
      var cosmetic = gov.bootstrapV2.cosmeticMutationTargets || [];
      if (actionable.length && actionable[0].count > 40) {
        var topTarget = String(actionable[0].target || '');
        var label = /document-shell:childList/.test(topTarget) ? 'document shell childList during boot' : topTarget;
        gov.primaryBlockers.push('Mutation source trace active: top actionable churn target is '+label+' ('+actionable[0].count+' samples).');
      } else if (cosmetic.length) {
        gov.notes = gov.notes || [];
        gov.notes.push('Cosmetic mutation noise classified separately: '+cosmetic.slice(0,4).map(function(t){return t.target+'='+t.count;}).join(', '));
      } else if (top.length && top[0].count > 40) {
        gov.primaryBlockers.push('Mutation source trace active: top churn target is '+String(top[0].target||'unknown')+' ('+top[0].count+' samples).');
      }
      return gov;
    };
    window.DSDRuntimeGovernance.__p11dz72Enhanced = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); setTimeout(enhanceGovernance, 50); }, { once:true }); else { boot(); setTimeout(enhanceGovernance, 50); }
  setTimeout(enhanceGovernance, 1800);
})();
